if (!customElements.get('multicolumn-icon')) {
  customElements.define(
    'multicolumn-icon',
    class MulticolumnIcon extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.dataset.enableMobileNavigation !== 'true') return;

        this.selectors = {
          wrapper: '.multicolumn__items',
          prev: '.multicolumn-icon__mobile-prev',
          next: '.multicolumn-icon__mobile-next',
        };

        this.wrapper = this.querySelector(this.selectors.wrapper);
        this.section = this.closest(`.section-${this.dataset.sectionId}`);
        this.prevButton = this.section.querySelector(this.selectors.prev);
        this.nextButton = this.section.querySelector(this.selectors.next);

        if (!this.wrapper || !this.prevButton || !this.nextButton) return;

        this.handlePrev = this.scrollMobile.bind(this, -1);
        this.handleNext = this.scrollMobile.bind(this, 1);

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.handleViewportChange.bind(this);
        this.handleViewportChange();
      }

      disconnectedCallback() {
        this.teardownMobileNavigation();
      }

      handleViewportChange() {
        if (FoxTheme.config.mqlMobile) {
          this.initMobileNavigation();
        } else {
          this.teardownMobileNavigation();
        }
      }

      initMobileNavigation() {
        if (this.mobileNavigationBound) return;

        this.prevButton.addEventListener('click', this.handlePrev);
        this.nextButton.addEventListener('click', this.handleNext);

        this.mobileNavigationBound = true;
      }

      teardownMobileNavigation() {
        if (!this.mobileNavigationBound) return;

        this.prevButton.removeEventListener('click', this.handlePrev);
        this.nextButton.removeEventListener('click', this.handleNext);

        this.mobileNavigationBound = false;
      }

      scrollMobile(direction, event) {
        event.preventDefault();

        const firstColumn = this.wrapper.querySelector('.f-column:not(.hidden)');
        if (!firstColumn) return;

        const columnGap = window.getComputedStyle(this.wrapper).getPropertyValue('--f-column-gap');
        const gap = parseFloat(columnGap.replace('rem', '')) * 10 || 0;
        const factor = FoxTheme.config.isRTL ? -1 : 1;
        const scrollAmount = (firstColumn.offsetWidth + gap) * direction * factor;

        this.scrollBy({
          left: scrollAmount,
          behavior: 'smooth',
        });
      }
    }
  );
}
